



























import { Component, mixins } from '@niknevis/vue-modules'
import { InjectReactive } from 'vue-property-decorator'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import PanelContentItemActions from '@/modules/content-item/components/panel/table/PanelContentItemActions.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import ContentItemStatusView from '@/modules/content-item/components/shared/ContentItemStatusView.vue'
import StepCheckByIcon from '@/modules/base-campaign-item/components/shared/StepCheckByIcon.vue'
import {
  ContentItemCollectionType,
  ContentItemCollectionWith
} from '@/modules/content-item/models/content-item-collection.model'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';

@Component({
  components: {
    TesTd,
    TesTr,
    PanelContentItemActions,
    QTooltip
  }
})
export default class PanelContentItemTableRow extends mixins<TesTableRow>(TesTableRow) {
  @InjectReactive()
  items!: ContentItemCollectionType

  get withData(): ContentItemCollectionWith {
    return {
      statuses: this.items.statuses,
      content_types: this.items.content_types
    }
  }

  columnComponents = {
    deliver_at: {
      component: DateTooltipped,
      handler: (value, row) => ({ isoDate: value })
    },
    status: {
      component: ContentItemStatusView,
      handler: (value, row, withData) => ({ status: row.status, statuses: withData.statuses })
    },
    main_keyword: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.main_keyword })
    },
    step: {
      component: StepCheckByIcon,
      handler: (value, row) => ({ step: row.step, status: row.status })
    },
    actions: {
      component: PanelContentItemActions,
      handler: (value, row, withData) => ({ contentItem: row, withData: withData })
    }
  }
}
